import { select } from '@ps/web-core-store';
import { mobileBreakpoint } from '@ps/web-core-utils';
import { useSelector } from 'react-redux';

import useScreenSize from '../useScreenSize/useScreenSize';

const useIsDesktop = () => {
  const isDesktopEmbedded = useSelector(select.device.isDesktopEmbedded);
  const { greaterThan } = useScreenSize();
  return isDesktopEmbedded || greaterThan(mobileBreakpoint);
};

export default useIsDesktop;
